import React from 'react';
import { gql } from '@apollo/client';
import { NumberField, Show, SimpleShowLayout, TextField } from 'react-admin';
import DateTimeField from 'components/DateTimeField';
import TimestampFields from 'components/TimestampFields';
import { CASE_QUERY_OPTIONS, PermittedLinkField } from 'components/IntegrationCaseFields';
import ProvisioningReportField from './ProvisioningReportField';

const EngagementCaseShow = () => (
  <Show queryOptions={CASE_QUERY_OPTIONS} data-testid="engagement-case-show">
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Case UID" source="uid" />
      <PermittedLinkField label="Company" source="location.company.name" typename="Company" />
      <PermittedLinkField label="Location" source="location.name" typename="Location" />
      <TextField label="Integration ID" source="company_integration_id" />
      <PermittedLinkField
        label="Professional ID"
        source="professional_id"
        typename="Professional"
      />
      <TextField label="First Name" source="first_name" />
      <TextField label="Last Name" source="last_name" />
      <TextField label="Email" source="email" />
      <DateTimeField label="Starts Date" source="starts_date" format="MM/dd/yyyy" />
      <DateTimeField label="Ends Date" source="ends_date" format="MM/dd/yyyy" />
      <DateTimeField label="Starts Time" source="starts_time" tzSource="location.timezone_lookup" />
      <DateTimeField label="Ends Time" source="ends_time" tzSource="location.timezone_lookup" />
      <NumberField label="Revision" source="state_revision" />
      <ProvisioningReportField label="Provisioning Report" />
      <NumberField label="Reported Revision" source="provisioning_reported_revision" />
      <DateTimeField
        label="Report Received At"
        source="provisioning_received_at"
        timeZone="America/Los_Angeles"
      />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

EngagementCaseShow.query = gql`
  query GET_ONE($id: Int!) {
    engagementCase(id: $id) {
      id
      uid
      company_integration_id
      professional_id
      first_name
      last_name
      email
      location {
        id
        name
        timezone_lookup
        company {
          id
          name
        }
      }
      starts_date
      ends_date
      starts_time
      ends_time
      state_revision
      provisioning_status
      provisioning_reported_revision
      provisioning_received_at
      provisioning_freshness
      created_at
      updated_at
    }
  }
`;

export default EngagementCaseShow;
